import { combineReducers } from 'redux';

import scrollTracking, { IScrollTrackingState } from './scrollTracking';
import spaTracking, { ISpaTrackingState } from './spaTracking';
import secureCookie, { ISecureCookieState } from './secureCookie';
import appDomainSettings, { SettingState } from './appDomainSettings';
import appDefaultDomainSettings from './appDefaultDomainSettings';
import installationCode, { AppInstallationCodeState } from './appInstallationCode';

const appReducers = combineReducers({
  scrollTracking,
  spaTracking,
  secureCookie,
  domainSettings: appDomainSettings,
  installationCode,
});

const appDefaultReducers = combineReducers({
  domainSettings: appDefaultDomainSettings,
});

export interface ContainerSettingsState {
  containerSettings: {
    app: {
      scrollTracking: IScrollTrackingState
      spaTracking: ISpaTrackingState
      secureCookie: ISecureCookieState
      installationCode: AppInstallationCodeState
      domainSettings: {
        fpc: SettingState
        containerJsPath: SettingState
        staticResourcesDomain: SettingState
        trackingDomain: SettingState
        trackingScriptPath: SettingState
        trackingEndpointPath: SettingState
        uiApisDomain: SettingState
      }
    }
    appDefault: {
      domainSettings: {
        fpc: SettingState
        containerJsPath: SettingState
        staticResourcesDomain: SettingState
        trackingDomain: SettingState
        trackingScriptPath: SettingState
        trackingEndpointPath: SettingState
        uiApisDomain: SettingState
      }
    }
  }
}

export default combineReducers({
  app: appReducers,
  appDefault: appDefaultReducers,
});
